@if (wrapper && wrapper.isReady) {
  <div [formGroup]="wrapper.form" [class]="getFormGroupClass()">
    <acc-form-label [name]="name" [wrapper]="wrapper" [size]="config.size"/>
    <div class="input-group">
      <select #tooltip="ngbTooltip"
              class="form-select shadow-none form-control" [class]="getEditClass()"
              [id]="name"
              [formControlName]="name"
              (change)="onSelectChange($event)"
              [class.is-invalid]="isInvalid()"
              [class.disabled]="isViewOnly()"
              [class.placeholder]="isPlaceholder()"
              (click)="showPlaceholder = false"
              (accClickOutside)="showPlaceholder = true"
              [ngbTooltip]="tooltipName">
        @if (isShowSelectionPrompt()) {
          <option [selected]="!hasSelectedOptions()" [ngValue]="null"
                  class="placeholder" disabled="disabled" hidden="hidden">
            @if (isPlaceholder()) {
              {{ 'form.select.selectionPrompt'|translate }}
            }
          </option>
        }
        @for (option of this.selectOptions; track option.value) {
          <option [value]="option.value" [selected]="isOptionSelected(option)">
            @if (option.hasTranslation()) {
              {{ option.translation | translate }}
            } @else {
              {{ option.name }}
            }
          </option>
        }
      </select>
      @if (showCleanAction()) {
        <span class="input-group-text acc-clean-action"
              [class]="getViewClass()"
              [ngbPopover]="'form.select.clear'|translate"
              [id]="name + '-clean-action'"
              (click)="cleanValue()" (keydown.enter)="cleanValue()" tabindex="0">
          <acc-icon name="typeahead-clean"/>
        </span>
      }
    </div>
    <acc-form-field-error [name]="name" [wrapper]="wrapper"/>
  </div>
}
